import React, {useEffect} from "react";
import {observer} from "mobx-react";
import {Button, Col, Form, Input, Layout, message, Modal, Pagination, Row, Space, Table, Tooltip} from "antd";
import {Content, Header} from "antd/es/layout/layout";
import styled from "styled-components";
import {useStore} from "../../store";
import {deleteBaseLibraryInfoApi, getBaseLibraryInfoApi} from "../../http/manager";
import {transaction} from "mobx";
import { BaseLibraryEntity } from "../../entity/base-library-entity";
import { ColumnsType } from "antd/lib/table";
import { TableRowSelection } from "antd/es/table/interface";
import BaseLibraryDetail from "./base-library-detail";
import BaseLibraryEdit from "./base-library-edit";
import UploadFile from "../common/upload-file";
import "../../css/table-scroll-y.css"

const BasicLibrary:React.FC = () => {
    const { baseLibraryStore } = useStore();
    useEffect(() => {
        queryBaseLibraryList()
        return baseLibraryStore.clear;
    },[])

    const columns: ColumnsType<BaseLibraryEntity> = [
        {
            title: '序号',
            width: 70,
            dataIndex: 'id',
            key: 'id',
            align:"center",
            render: (value, record, index) => {
                return String(index+1)
            }
        },
        {
            title: '物种中文名',
            width: 200,
            dataIndex: 'speciesZhName',
            key: 'speciesZhName',
            align:"center"

        },
        {
            title: 'canonical_name（物种拉丁名）',
            width: 300,
            dataIndex: 'canonicalName',
            key: 'canonicalName',
            align:"center",
            ellipsis: {
                showTitle: false,
            },
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>
                    {text}
                </Tooltip>
            ),
        },
        {
            title: 'species author',
            width: 150,
            dataIndex: 'speciesAuthor',
            key: 'speciesAuthor',
            align:"center"
        },
        {
            title: 'Class（纲）',
            width: 150,
            dataIndex: 'speciesClass',
            key: 'speciesClass',
            align:"center"
        },
        {
            title: 'Order（目）',
            width: 150,
            dataIndex: 'speciesOrder',
            key: 'speciesOrder',
            align:"center"
        },
        {
            title: 'Family（科））',
            width: 150,
            dataIndex: 'speciesFamily',
            key: 'speciesFamily',
            align:"center"
        },
        {
            title: '科中文名',
            width: 150,
            dataIndex: 'speciesFamilyName',
            key: 'speciesFamilyName',
            align:"center"
        },
        {
            title: '操作',
            width: 300,
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
            align:"center",
            render: (value, record) => {
                return  <Space size="middle">
                    <Button onClick={() => toEditModal(record)} type={"primary"} >编辑</Button>
                    <Button onClick={ () => toDetailModal(record)} type={"primary"}>详情</Button>
                    <Button onClick={() => openDeleteConfirm(record)} type={"primary"} danger={true}>删除</Button>
                </Space>
            }
        },
    ];

    const toEditModal = (record:BaseLibraryEntity) => {
        baseLibraryStore.setBaseLibraryDetail(record);
        baseLibraryStore.setShowEdit(true)
    }

    const toDetailModal = (record:BaseLibraryEntity) => {
        baseLibraryStore.setBaseLibraryDetail(record);
        baseLibraryStore.setShowDetail(true)
    }

    const setNameCn = (e:any) => {
        baseLibraryStore.condition.speciesZhName = e.target.value;
    }

    const setLatin = (e:any) => {
        baseLibraryStore.condition.canonicalName = e.target.value;
    }

    const setClass = (e:any) => {
        baseLibraryStore.condition.speciesClass = e.target.value;
    }

    const setOrder = (e:any) => {
        baseLibraryStore.condition.speciesOrder = e.target.value;
    }

    const setFamily = (e:any) => {
        baseLibraryStore.condition.speciesFamily = e.target.value;
    }
    const setFamilyCn = (e:any) => {
        baseLibraryStore.condition.speciesFamilyName = e.target.value;
    }
    const setGenus = (e:any) => {
        baseLibraryStore.condition.genus = e.target.value;
    }
    const onResetOnclick = () => {
        baseLibraryStore.resetQueryCondition();
        onQuery();
    }
    const openDeleteConfirm = (record:BaseLibraryEntity) => {
        baseLibraryStore.showDeleteConfirm(true);
        baseLibraryStore.setDeleteRecord(record);
    }
    const onDeleteConfirmClose = () => {
        baseLibraryStore.showDeleteConfirm(false);
    }
    const deleteButton = () => {
        const params = {
            id: baseLibraryStore.deleteRecord.id,
        }
        deleteBaseLibrary(params);
    }
    const deleteBatch = () => {

    }

    const deleteBaseLibrary = (params:any) => {
        deleteBaseLibraryInfoApi(params)
            .then((res) => {
                if (Number(res.code) === 200) {
                    message.success("删除成功");
                    onDeleteConfirmClose()
                    queryBaseLibraryList(false);
                } else {
                    if (res.message) {
                        message.error(res.message);
                    } else {
                        message.error("删除失败");
                    }
                }
            }).catch(() => {
                message.error("删除失败");
        })
    }

    const queryBaseLibraryList = (isClear:boolean = true) => {
        const params = {
            speciesZhName: baseLibraryStore.condition.speciesZhName,
            canonicalName: baseLibraryStore.condition.canonicalName,
            speciesClass: baseLibraryStore.condition.speciesClass,
            speciesOrder: baseLibraryStore.condition.speciesOrder,
            speciesFamily: baseLibraryStore.condition.speciesFamily,
            speciesFamilyName: baseLibraryStore.condition.speciesFamilyName,
            pageNum: baseLibraryStore.pagination.pageNum,
            pageSize: baseLibraryStore.pagination.pageSize,
            genus: baseLibraryStore.condition.genus,
        }
        getBaseLibraryInfoApi(params)
            .then((res) => {
                refreshTableData((res.data && res.data.list && res.data.list.length > 0) ? res.data.list : []);
                baseLibraryStore.pagination.total = res.data ? Number(res.data.total) : 0;
            })
    }

    const refreshTableData = (data:BaseLibraryEntity[]) => {
        const list:BaseLibraryEntity[] = [];
        data.forEach((item) => {
            item.key = String(item.id);
            list.push(item);
        })
        transaction(() => {
            baseLibraryStore.setDataSource(list);
        })
    }

    const onQuery = () => {
        baseLibraryStore.clearSelectedRows();
        queryBaseLibraryList();
    }

    const rowSelection: TableRowSelection<BaseLibraryEntity> = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log("dtl---change",`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            baseLibraryStore.setSelectedRows(selectedRows);
        },
        onSelect: (record, selected, selectedRows) => {
            console.log("dtl---select",record, selected, selectedRows);
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            console.log("dtl---selectall", selected, selectedRows, changeRows);
        },
    };

    const OnDetailModalClose = () => {
        baseLibraryStore.setShowDetail(false);
    }

    const OnEditModalClose = () => {
        baseLibraryStore.setShowEdit(false);
    }

    const onEditSuccess = () => {
        OnEditModalClose();
        queryBaseLibraryList(false);
    }

    const onUploadClose = () => {
        baseLibraryStore.setShowUpload(false);
    }

    const openUploadFileModal = () => {
        baseLibraryStore.setShowUpload(true);
    }

    const onUploadSuccess = () => {
        onUploadClose();
        onQuery()
    }

    const onSizeChange = (page:any, pageSize:any) => {
        baseLibraryStore.pagination.pageSize = pageSize;
        baseLibraryStore.pagination.pageNum = page;
        onQuery();
    }

    return(
        <Layout style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Header style={{background: "#ffffff", borderBottom: "1px solid #d3d3d3", padding:"0 0 0 0"}}>
                <TitleSpan>基础库维护</TitleSpan>
            </Header>
            <Content style={{ flex: 1, overflow: 'hidden' }}>
                <Wrapper>
                    <SearchWrapper>
                        <Button onClick={openUploadFileModal} type={"primary"} style={{width:"100px", margin: "15px 0 15px 15px"}} size={"large"}>批量上传</Button>
                        <Form labelAlign={"right"} wrapperCol={{span:"15"}}>
                            <Row justify={"space-between"} gutter={[15, 0]} style={{padding: "0 15px"}}>
                                <Col span={6}>
                                    <Form.Item  labelCol={{span:"7"}} label={"物种中文名"}><Input onChange={setNameCn}
                                                                      value={baseLibraryStore.condition.speciesZhName}
                                                                      placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item  labelCol={{span:"7"}} label={"物种拉丁名"}><Input onChange={setLatin}
                                                                      value={baseLibraryStore.condition.canonicalName}
                                                                      placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item  labelCol={{span:"7"}} label={"Class(纲)"}><Input onChange={setClass}
                                                                         value={baseLibraryStore.condition.speciesClass}
                                                                         placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item  labelCol={{span:"7"}} label={"Order(目)"}><Input onChange={setOrder}
                                                                         value={baseLibraryStore.condition.speciesOrder}
                                                                         placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item  labelCol={{span:"7"}} label={"Family(科)"}><Input onChange={setFamily}
                                                                          value={baseLibraryStore.condition.speciesFamily}
                                                                          placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item  labelCol={{span:"7"}} label={"科中文名"}><Input onChange={setFamilyCn}
                                                                     value={baseLibraryStore.condition.speciesFamilyName}
                                                                     placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item  labelCol={{span:"7"}} label={"genus(属)"}><Input onChange={setGenus}
                                                                         value={baseLibraryStore.condition.genus}
                                                                         placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6} style={{paddingLeft:"25px"}}>
                                    <Space size={["middle", "large"]}>
                                        <Button onClick={onQuery} type={"primary"}>查询</Button>
                                        <Button onClick={onResetOnclick} type={"default"}>重置</Button>
                                        {/*<Button onClick={onResetOnclick} type={"primary"} danger={true}>批量删除</Button>*/}
                                    </Space>
                                </Col>
                            </Row>
                        </Form>
                    </SearchWrapper>
                    <ContentWrapper>
                        <Table
                            rowClassName={ (type,index, intent) => {
                                return index%2 === 0 ? "tableItemWhite" : "tableItemGray";
                            }}
                            style={{margin: "15px 15px 0 15px"}}
                            size={"small"}
                            bordered={true}
                            // rowSelection={{...rowSelection,fixed:"left", type:"checkbox"}}
                            dataSource={baseLibraryStore.dataSource}
                            columns={columns}
                            scroll={{x: true}}
                            pagination={{position: [], pageSize: baseLibraryStore.pagination.pageSize}}
                        />
                        <Pagination
                            size={"small"}
                            style={{margin:"15px 15px 15px 0", alignSelf:"end"}}
                            total={baseLibraryStore.pagination.total}
                            showQuickJumper={true}
                            showSizeChanger={true}
                            defaultPageSize={10}
                            hideOnSinglePage={false}
                            onChange={onSizeChange}
                            current={baseLibraryStore.pagination.pageNum}
                        />
                    </ContentWrapper>
                </Wrapper>
                <Modal onCancel={OnDetailModalClose}
                       width={"700px"}
                       open={baseLibraryStore.isShowDetail}
                       closable={true}
                       centered={true}
                       footer={null}
                       title={"基础库详情"}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <BaseLibraryDetail/>
                </Modal>
                <Modal onCancel={OnEditModalClose}
                       width={"700px"}
                       open={baseLibraryStore.isShowEdit}
                       closable={true}
                       centered={true}
                       destroyOnClose={true}
                       footer={null}
                       mask={true}
                       title={"编辑"}
                       maskClosable={true}>
                    <BaseLibraryEdit onSuccess={onEditSuccess}/>
                </Modal>
                <Modal onCancel={onUploadClose}
                               width={"500px"}
                               open={baseLibraryStore.isShowUpload}
                               closable={true}
                               centered={true}
                               destroyOnClose={true}
                               footer={null}
                               mask={true}
                               maskClosable={true}>
                    <UploadFile onSuccess={onUploadSuccess} funType={1}/>
                </Modal>
                <Modal onCancel={onDeleteConfirmClose}
                       onOk={deleteButton}
                       width={"300px"}
                       okType={"primary"}
                       okText={"确认"}
                       open={baseLibraryStore.isShowDeleteCOnfirm}
                       closable={true}
                       title={"提示"}
                       centered={true}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <div>确认删除该数据</div>
                </Modal>
            </Content>
        </Layout>
    );
}

export default observer(BasicLibrary);

const TitleSpan = styled.span`
  & {
    font-size: 20px;
    line-height: 16px;
    text-align: center;
    color: #333333;
    font-weight: 450;
    margin-left: 15px;
  }
`;
const Wrapper = styled.div`
  & {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: auto;
    .tableItemWhite{
      background: white;
    }
    .tableItemGray{
      background: #F9FAFD;
    }
    .ant-table-body {
      overflow-x: scroll !important;
    }
    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
    ::-webkit-scrollbar {
      width: 0px;
      height: 10px !important;
    }
  }
`;
const SearchWrapper = styled.div`
  & {
    margin: 15px 15px 0 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
  }
`;
const ContentWrapper = styled.div`
  & {
    margin: 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
  }
`;
